import React, { useState } from 'react';
import { Form, Button } from 'antd';
import './LoginVarification.css';
import Index from '../Index';
import VerificationInput from 'react-verification-input';
// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";

const VarifyLogin = () => {
    const mainLogo = '/assets/QA_Logo.svg';
    // let dispatch = useDispatch();
    //   let Navigate = useNavigate();
    const [verificationValue, setVerificationValue] = useState('');

    const handleVerificationChange = (value) => {
        setVerificationValue(value);
    };

    const onFinish = () => {};
    return (
        <>
            <div className='verification-container'>
                <Index />
                <div className='verification-main auth-custom-scrollbar'>
                    <div className='verification-div'>
                        <div className='center-img'>
                            <img
                                src={mainLogo}
                                alt=''
                                className='centered-image'
                            />
                        </div>

                        <p className='verification_text'>Verify it’s you</p>
                        <p className='verification_midtext'>
                            A verification code has been sent to your email.
                            This code will be valid for 15 minutes.
                        </p>
                        <Form
                            name='verification'
                            initialValues={{ code: '' }}
                            onFinish={onFinish}
                            className='verification-class-form'>
                            <div className='Verification_input'>
                                <VerificationInput
                                    value={verificationValue}
                                    onChange={handleVerificationChange}
                                />
                            </div>
                            <Form.Item>
                                <Button
                                    style={{ marginTop: '30px' }}
                                    type='primary'
                                    htmlType='submit'
                                    block
                                    className='submit_login-btn'>
                                    Verify & Login
                                </Button>
                            </Form.Item>

                            <div className='lofin-varify-second'>
                                Wait 16 seconds before requesting a new code.
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default VarifyLogin;
